import React, { useState } from 'react';
import { Badge, UncontrolledTooltip } from 'reactstrap';

/**
 * Componente para mostrar percentiles de forma compacta con tooltip
 * 
 * @param {Object} percentiles - Objeto con p25, p50, p75, p90, p95, p99
 * @param {string} label - Etiqueta para el tooltip
 */
const PercentilesBadge = ({ percentiles, label = "Percentiles" }) => {
  if (!percentiles) return null;

  const tooltipId = `percentiles-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <>
      <Badge 
        color="light" 
        className="text-muted fs-8 px-2 py-1 cursor-pointer"
        id={tooltipId}
      >
        <i className="ri-bar-chart-box-line me-1"></i>
        P50: ${percentiles.p50?.toFixed(2) || '0.00'}
      </Badge>
      
      <UncontrolledTooltip placement="top" target={tooltipId}>
        <div className="text-start">
          <strong>{label}</strong>
          <hr className="my-1" />
          <div className="d-flex justify-content-between gap-3">
            <div>
              <small>P25:</small> <strong>${percentiles.p25?.toFixed(2)}</strong>
            </div>
            <div>
              <small>P50:</small> <strong>${percentiles.p50?.toFixed(2)}</strong>
            </div>
            <div>
              <small>P75:</small> <strong>${percentiles.p75?.toFixed(2)}</strong>
            </div>
          </div>
          <div className="d-flex justify-content-between gap-3 mt-1">
            <div>
              <small>P90:</small> <strong>${percentiles.p90?.toFixed(2)}</strong>
            </div>
            <div>
              <small>P95:</small> <strong>${percentiles.p95?.toFixed(2)}</strong>
            </div>
            <div>
              <small>P99:</small> <strong>${percentiles.p99?.toFixed(2)}</strong>
            </div>
          </div>
          <hr className="my-1" />
          <small className="text-muted">
            <i className="ri-information-line"></i> P50 = Mediana (50% de valores)
          </small>
        </div>
      </UncontrolledTooltip>
    </>
  );
};

export default PercentilesBadge;
